import { DropDownArrowIcon } from '../../assets/icons/Svg';

interface DropdownBtnProps {
    label: string;
    isOpen: boolean;
    setIsOpenStatus?: (value: boolean) => void;
    onClick?: () => void;
    isCustomClass?: boolean
    customClass?: string
    disabled?: boolean
    arrowIconColor?: string;
}

export default function DropdownBtn({ onClick, label, isOpen, setIsOpenStatus, isCustomClass, customClass, disabled, arrowIconColor }: DropdownBtnProps) {
    
    const handleClick = () => {
        if (onClick) {
            onClick();
            return;
        }

        setIsOpenStatus?.(!isOpen);
    };
    
    return (
        <button
            onClick={handleClick}
            className={`${isCustomClass === true ? customClass : 'flex w-full justify-between items-center font-medium rounded transition px-4 bg-cbColor text-white shadow-md py-2 space-x-2'} ${disabled && 'cursor-not-allowed bg-gray-100'}`}
            disabled={disabled}
            // className="flex w-full justify-between items-center font-medium rounded transition px-4 bg-orange-500 text-white shadow-md py-2 space-x-2"
        >
            <span className="text-xs">{label}</span>
            <div>
                <DropDownArrowIcon 
                    isOpen={isOpen}
                    color={`${arrowIconColor} ${isCustomClass === true ? 'text-black' : 'text-white'}`}
                />
            </div>
        </button>
    )
}
